import { CSRF_HEADER } from '@aurea/contracts';
import { Button, Field, Input } from '@aurea/ui';
import { useMutation } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';
import type { FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthCard } from '../components/AuthCard';
import { useErrorText } from '../lib/i18n';

export const Route = createFileRoute('/forgot')({ component: Forgot });

function Forgot() {
  const { t } = useTranslation();
  const errorText = useErrorText();
  const send = useMutation({
    mutationFn: async (email: string) => {
      const res = await fetch('/api/v1/auth/password/forgot', {
        method: 'POST',
        headers: { 'content-type': 'application/json', [CSRF_HEADER]: '1' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error(String(res.status));
    },
  });
  const submit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    send.mutate(String(new FormData(e.currentTarget).get('email')).trim());
  };
  return (
    <AuthCard title={t('forgot.title')} lead={send.isSuccess ? t('forgot.sent') : t('forgot.lead')}>
      {!send.isSuccess && (
        <form className="flex flex-col gap-4" onSubmit={submit}>
          <Field label={t('login.email')} error={send.isError ? errorText(send.error) : undefined}>
            <Input name="email" type="email" autoComplete="username" required autoFocus />
          </Field>
          <Button type="submit" loading={send.isPending}>
            {t('forgot.submit')}
          </Button>
        </form>
      )}
      <Link to="/login" className="btn-link mt-4 inline-block">
        {t('forgot.back')}
      </Link>
    </AuthCard>
  );
}
